import React from "react";
import { Flex, Box } from "rebass";
import FlatButton from "material-ui/FlatButton";
import ActionAdd from "material-ui/svg-icons/content/add";
import ViewList from "material-ui/svg-icons/action/view-list";
import DownloadKol from "./DownloadKol";
import DownloadTemplate from "./DownloadTemplate";
import { IconTitle } from "../components";

export const DivFormContainer = Box.extend`
  padding-top: 3em;
  @media only screen and (min-width: 768px) {
    padding-bottom: 1em;
    padding-top: 0em;
  }
`;

export const HeaderTitle = props => {
  return (
    <Flex
      w={[1]}
      direction={["column", "row"]}
      justify={["center", "space-between"]}
    >
      <IconTitle icon="agency" title={"resources.agency.marketerTitle"} />
      <Flex
        px={[1]}
        pt={[1, 0]}
        align={["flex-end", "flex-start"]}
        justify={["flex-end"]}
        direction={["row"]}
        wrap
      >
        <DownloadTemplate {...props} />
        <DownloadKol {...props} />
        <FlatButton
          icon={<ActionAdd />}
          label="Import"
          href={`#${props.match.url}/import`}
          primary={true}
        />
        <FlatButton
          icon={<ActionAdd />}
          href={`#${props.match.url}/create`}
          label="Create"
          primary={true}
        />
      </Flex>
    </Flex>
  );
};

export const HeaderTitleCreate = props => {
  const url = props.match.url;
  const newUrl = url.replace("/create", "");
  return (
    <Flex
      w={[1]}
      direction={["column", "row"]}
      justify={["center", "space-between"]}
    >
      <IconTitle icon="agency" title={"resources.agency.newMarketerTitle"} />
      <Flex
        px={[1]}
        pt={[1, 0]}
        align={["flex-end", "flex-start"]}
        justify={["flex-end"]}
        direction={["row"]}
        wrap
      >
        <FlatButton
          icon={<ViewList />}
          label="List"
          href={`#${newUrl}`}
          primary={true}
        />
      </Flex>
    </Flex>
  );
};

export const HeaderTitleEdit = props => {
  const url = props.match.url;
  const newUrl = url.replace(`/${props.match.params.agencyid}`, "");
  return (
    <Flex
      w={[1]}
      direction={["column", "row"]}
      justify={["center", "space-between"]}
    >
      <IconTitle icon="agency" title={"resources.agency.editMarketerTitle"} />
      <Flex
        px={[1]}
        pt={[1, 0]}
        align={["flex-end", "flex-start"]}
        justify={["flex-end"]}
        direction={["row"]}
        wrap
      >
        <FlatButton
          icon={<ViewList />}
          label="List"
          href={`#${newUrl}`}
          primary={true}
        />
      </Flex>
    </Flex>
  );
};
export const HeaderTitleImport = props => {
  const url = props.match.url;
  const newUrl = url.replace("/import", "");
  return (
    <Flex
      w={[1]}
      direction={["column", "row"]}
      justify={["center", "space-between"]}
    >
      <IconTitle icon="agency" title={"resources.agency.importTitle"} />
      <Flex
        px={[1]}
        pt={[1, 0]}
        align={["flex-end", "flex-start"]}
        justify={["flex-end"]}
        direction={["row"]}
        wrap
      >
        <FlatButton
          icon={<ViewList />}
          label="List"
          href={`#${newUrl}`}
          primary={true}
        />
      </Flex>
    </Flex>
  );
};

export const HeaderTitleChart = props => {
  return (
    <Flex
      w={[1]}
      direction={["column", "row"]}
      justify={["center", "space-between"]}
    >
      <IconTitle icon="agency" title={"resources.agency.titleChart"} />
      <Flex
        px={[1]}
        pt={[1, 0]}
        align={["flex-end", "flex-start"]}
        justify={["flex-end"]}
        direction={["row"]}
        wrap
      >
        <FlatButton
          icon={<ViewList />}
          href={`#/agency`}
          label="List"
          primary={true}
        />
      </Flex>
    </Flex>
  );
};



// WEBPACK FOOTER //
// ./src/agency/styled.js